import type { FC } from "react";

import HygieneModal from "@/components/modals/profil-hygiene/hygiene-modal";
import type { Patient } from "@/types/api/patient";

export type HygieneUpdateModalProps = {
  hygieneModalOpen: "sports" | "diet" | "none";
  setHygieneModalOpen: React.Dispatch<
    React.SetStateAction<"sports" | "diet" | "none">
  >;
  patient: Patient;
};

const HygieneUpdateModal: FC<HygieneUpdateModalProps> = ({
  hygieneModalOpen,
  setHygieneModalOpen,
  patient,
}) => {
  switch (hygieneModalOpen) {
    case "diet":
    case "sports":
      return (
        <HygieneModal
          hygieneModalOpen={hygieneModalOpen}
          setHygieneModalOpen={setHygieneModalOpen}
          patient={patient}
        />
      );
    case "none":
      return null;
  }
};

export default HygieneUpdateModal;
